import {Component, Input} from '@angular/core';
import {map} from 'rxjs/operators';
import {AuthorizationService} from '../../../authorization/authorization.service';
import {ExecutorModel} from '../../models/executor.model';
import {BaseInteractionButtonsComponent} from '../../../shared/card-view/base-interaction-buttons/base-interaction-buttons.component';

@Component({
  selector: 'app-executor-interaction-buttons',
  templateUrl: './executor-interaction-buttons.component.html',
  styleUrls: ['../../../shared/card-view/base-interaction-buttons/base-interaction-buttons.component.scss'],
})
export class ExecutorInteractionButtonsComponent extends BaseInteractionButtonsComponent {
  modelData: ExecutorModel;

  constructor(
    private authorizationService: AuthorizationService,
  ) {
    super();
  }

  @Input() set model(model: ExecutorModel) {
    this.modelData = model;
    this.buttons = this.authorizationService.getEntityAccessRights().pipe(
      map(
        () => [
          {
            id: 'tel',
            iconClass: 'ic-tel',
            title: 'Call',
            isVisible: this.hasValue(model.login),
            action: () => {
              window.location.href = 'tel:' + model.login;
            }
          },
          {
            id: 'whatsapp',
            iconClass: 'ic-whatsapp',
            title: 'WhatsApp',
            isVisible: this.hasValue(model.login),
            action: () => {
              window.open('https://api.whatsapp.com/send?phone=' + this.formatPhoneForWhatsUp(model.login), '_blank');
            }
          },
          {
            id: 'add-iot',
            iconClass: 'ic-iot-mask',
            title: 'Add device',
            isVisible: true,
            action: () => {
              this.toggleForm('add-iot');
            }
          },
        ]
      )
    );
  }
}
